import { Toaster } from 'sonner';
import { useTheme } from './theme-provider';

export function ToastProvider() {
  const { theme } = useTheme();

  return (
    <Toaster
      theme={theme}
      // bottom-right: top-right sits exactly over the workspace header
      // actions (Save/Share/Export/Cancel), and the persistent generation
      // progress toast was hiding them for entire multi-minute runs.
      // The offset keeps toasts clear of the fixed bottom-6 right-6
      // "Making slides editable" progress indicators.
      position="bottom-right"
      offset={{ bottom: 96 }}
      richColors
      closeButton
      toastOptions={{
        style: {
          background: 'hsl(var(--card))',
          border: '1px solid hsl(var(--border))',
          color: 'hsl(var(--foreground))',
        },
        className: 'backdrop-blur-lg',
      }}
    />
  );
}